// fieldDefinitions.js
export const senderFields = [
  { label: "first_name", field: "firstName" },
  { label: "last_name", field: "lastName" },
  {
    label: "city",
    field: "city",
    options: [],
  },
  {
    label: "street",
    field: "street",
    options: [],
    dependsOn: "city",
  },
  { label: "building_num", field: "buildingNum", maxLength: 3 },
  { label: "apartment_num", field: "ApartmentNum", maxLength: 3 },
  { label: "zip", field: "zip" },
  { label: "area_code", field: "areaCode" },
  { label: "phone_number", field: "phoneNumber", maxLength: 7 },
];

export const receiverFields = [
  { label: "first_name", field: "firstName" },
  { label: "last_name", field: "lastName" },
  {
    label: "city",
    field: "city",
    options: [],
  },
  {
    label: "street",
    field: "street",
    options: [],
    dependsOn: "city",
  },
  { label: "building_num", field: "buildingNum", maxLength: 3 },
  { label: "apartment_num", field: "ApartmentNum", maxLength: 3 },
  { label: "zip", field: "zip" },
  { label: "area_code", field: "areaCode" },
  { label: "phone_number", field: "phoneNumber", maxLength: 7 },
];

export const businessFields = [
  { label: "company", field: "company" },
  { label: "company_id", field: "companyId" },
  {
    label: "company_city",
    field: "city",
    options: [],
  },
  {
    label: "company_street",
    field: "street",
    options: [],
    dependsOn: "city",
  },
];

export const collectionBucketFields = [
  { label: "area_code", field: "areaCode" },
  { label: "phone_number", field: "phoneNumber", maxLength: 7 },
];
